<template>
  <v-container grid-list-xl pb-0 class="file-upload">

    <vue-dropzone  v-if="(this.userRole === 'Sub Foreman' && this.step === 'Execution') || this.userRole !=='Sub Foreman'" ref="myVueDropzone" id="my-dropzone" v-on:vdropzone-file-added="sendingEvent" v-on:vdropzone-complete="uploaded" :options="dropzoneOptions"></vue-dropzone>

    <document-upload-table v-if="displayDoc" :stage="step" />
    <image-upload-table v-if="displayImage" :type="imageType"  :stage="step"/>
    <change-order-cards v-if="displayChange" :stage="step" />

    <v-snackbar v-model="showMessage" color="error">
      {{ message }}
      <v-btn icon color="white" text @click="showMessage = false, message = 'Error uploading file'">
        <v-icon size="28">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import DocumentUploadTable from '@/components/files/DocumentUploadTable'
import ImageUploadTable from '@/components/files/ImageUploadTable'
import ChangeOrderCards from '@/components/files/ChangeOrderCards'
import { mapActions, mapGetters } from 'vuex'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { AUTH_HEADERS_DROPZONE } from '@/utils/config'

export default {
  name: 'FileUpload',
  components: {
    DocumentUploadTable,
    ImageUploadTable,
    ChangeOrderCards,
    vueDropzone: vue2Dropzone
  },
  props: {
    uploadType: {
      type: String,
      default: 'document' // Default document, other options image & change
    },
    imageType: {
      type: String,
      default: null
    },
    step: {
      type: String,
      default: null
    }
  },
  created () {
    if (this.uploadType === 'document') {
      this.dropzoneOptions.dictDefaultMessage = 'Drop document files here to upload, Max 15 at a time'
    }
    if (this.uploadType === 'image') {
      this.dropzoneOptions.dictDefaultMessage = 'Drop image files here to upload, Max 15 at a time'
    }
    if (this.uploadType === 'change') {
      this.dropzoneOptions.dictDefaultMessage = 'Drop change order files here to upload, Max 15 at a time'
    }
  },
  data: () => ({
    displayDoc: false,
    displayImage: false,
    displayChange: false,
    showMessage: false,
    message: 'Error uploading files, you may have tried to uploaded too many.',
    dropzoneOptions: {
      url: `${process.env.VUE_APP_BASE_URL}`,
      thumbnailWidth: 150,
      maxFilesize: 100, // Massive for portfolios
      autoProcessQueue: false,
      autoQueue: false,
      parallelUploads: 15, // number of files that can be uploaded in the que
      maxFiles: 15,
      timeout: 100000,
      dictDefaultMessage: 'Drop files here to upload, Max 15 at a time',
      headers: { 'Authorization': AUTH_HEADERS_DROPZONE() }
    }
  }),
  mounted () {
    this.loadAllDocumentTypes()
    this.archivedDocTypes()

    if (this.uploadType === 'document') {
      this.displayDoc = true
    }
    if (this.uploadType === 'image') {
      this.displayImage = true
    }
    if (this.uploadType === 'change' && this.changeOrders.length > 0) {
      this.displayChange = true
    }
  },
  methods: {
    ...mapActions({
      loadAllDocumentTypes: 'documentType/loadAllDocumentTypes',
      archivedDocTypes: 'documentType/loadArchives',
      loadDocs: 'document/loadDocsByTask',
      loadImages: 'image/loadImagesByTask',
      loadChangeOrders: 'changeOrder/loadByTask',
      createChangeOrder: 'changeOrder/createChangeOrder',
      getFiles: 'file/getTaskFiles'
    }),
    async url (type) {
      var url = ''

      switch (type) {
        case 'document':
          url = `${process.env.VUE_APP_BASE_URL}workOrderDocument/createUpload?workOrderTaskId=${this.selectedTask.id}&userId=${this.id}&stage=${this.step}`
          break
        case 'image':
          // Auto populating the image type for each stage
          var imageTypeId = null
          if (this.imageType != null) {
            this.types.forEach(x => {
              if (this.imageType === x.text) {
                imageTypeId = x.value
              }
            })
          }
          url = `${process.env.VUE_APP_BASE_URL}workOrderImage/createUpload?workOrderTaskId=${this.selectedTask.id}&userId=${this.id}&documentTypeId=${imageTypeId}`
          break
        case 'change':
          // change order doc url requires a Change Order to be first created
          await this.createNewChangeOrder()
          url = `${process.env.VUE_APP_BASE_URL}changeOrderDocument/createUpload?changeOrderId=${this.changeOrder.id}&userId=${this.id}&status=Submitted`
          break
        default:
          // do nothing, files should always be in one of 3 categories
      }

      this.$refs.myVueDropzone.options.url = url
      this.$refs.myVueDropzone.dropzone.options.url = url
      this.dropzoneOptions.url = url
    },
    async uploaded (response) {
      if (response.status === 'success') {
        switch (this.uploadType) {
          case 'document':
            await this.loadDocs(this.selectedTask.id)
            break
          case 'image':
            await this.loadImages({ taskId: this.selectedTask.id, size: 'small' })
            break
          case 'change':
            await this.loadChangeOrders(this.selectedTask.id)
            break
          default:
          // Do nothing
        }
        this.updateCloseOutFiles()
      } else {
        this.showMessage = true
      }

      this.$refs.myVueDropzone.removeAllFiles()
    },
    async sendingEvent(file) {
      // Update URL!
      await this.url(this.uploadType)

      // Queue Files and Proccess (have to do manual queue for change orders to work)
      // Image files uploaded in non image tabs will be rejected
      if (file.type.startsWith('image/') && (this.uploadType === 'document' || this.uploadType === 'change')) {
        // error
        // error if its not an image uploaded to wrong tab
        this.message = 'This is an image, please upload in an image tab'
        this.showMessage = true
        this.$refs.myVueDropzone.removeFile(file)
      } else if (this.uploadType === 'image' && !file.type.startsWith('image/')) {
        // error if its not an image being uploaded in the image tab
        this.message = 'This is not an image, please upload in a document or change order tab'
        this.showMessage = true
        this.$refs.myVueDropzone.removeFile(file)
      } else {
        this.$refs.myVueDropzone.dropzone.enqueueFile(file)
        this.$refs.myVueDropzone.processQueue()
      }
    },
    async createNewChangeOrder () {
      let newOrder = { workOrderTaskId: this.selectedTask.id, userId: this.id, stageCreatedAt: this.step, status: 'Submitted' }
      await this.createChangeOrder(newOrder)
    },
    async updateCloseOutFiles () {
      let closeOutFiles = {
        taskID: this.selectedTask.id,
        archived: false
      }
      await this.getFiles(closeOutFiles)
    }
  },
  computed: {
    ...mapGetters({
      errorImage: 'image/error',
      types: 'documentType/selectList',
      id: 'user/id',
      images: 'image/imagesByTask',
      documents: 'document/documentsByTask',
      changeOrders: 'changeOrder/changeOrdersByTask',
      selectedTask: 'workOrderTask/selectedTask',
      changeOrder: 'changeOrder/changeOrder',
      userRole: 'user/role'
    })
  }
}
</script>
<style>
  .upload-container {
    padding: 20px 0;
    background-color: #f8f8f8;
    border-radius: 4px;
  }

  #my-dropzone {
  background-color: #f8f8f8;
  border-color: #f0a73a;
  border-radius: 4px;
  color: #f0a73a !important;
  text-align: center;
  width: 100%;
}
    #my-dropzone .dz-details {
      background-color: #1e345d !important;
    }
</style>
